<template>
  <div class="project-page">
    <Header type="black" />
    
    <div v-if="loading" class="loading-screen" style="min-height: 80vh; display: flex; align-items: center; justify-content: center; background-color: #131619;">
      <h2 style="color: white;">Yükleniyor...</h2>
    </div>

    <div v-else-if="!project" class="error-screen" style="min-height: 80vh; display: flex; flex-direction: column; align-items: center; justify-content: center; background-color: #131619;">
      <h2 style="color: #ff6b6b; margin-bottom: 20px;">Bu proje veritabanında bulunamadı!</h2>
      <p style="color: #ccc; margin-bottom: 30px;">Lütfen Admin paneli üzerinden projenin eklendiğinden emin olun.</p>
      <div style="width: 200px;">
        <router-link :to="`/${$route.params.locale || 'tr'}/projects`" style="text-decoration: none;">
          <Button type="transparent" href="#" text="Projelere Dön" :link="null" target="_self" />
        </router-link>
      </div>
    </div>

    <div v-else class="_container">
      <div style="width: 150px; color: white; padding-top: 3%; margin-left: 5%;">
          <router-link :to="`/${$route.params.locale || 'tr'}/projects`" style="text-decoration: none;">
            <Button type="transparent" href="#" :text="$t('button.back')" :link="null" target="_self" />
          </router-link>
      </div>
      
      <div class="introContainer">
          <div class="introColImg">
              <img class="introImg" v-if="project.imageUrl" :src="project.imageUrl" :alt="project.title">
          </div>
          <div class="introColText">
              <h1 class="introTitle">
                  {{ project.detailTitle || project.title }}
              </h1>
              <p class="introSubtitle">
                 {{ project.detailDesc }}
              </p>
          </div>
      </div>

      <div class="technicalContainer" v-if="formattedSpecs.length > 0">
          <div class="technicalColText">
              <h1 class="technicalTitle">Proje Özellikleri</h1>
              <div class="technicalSubtitle">
                  <ul class="technicalList">
                      <li v-for="(spec, index) in formattedSpecs" :key="index">{{ spec }}</li>
                  </ul>
              </div>
          </div>
      </div>
    </div>
    
    <Footer />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import AOS from 'aos';
import Header from '../components/common/Header.vue';
import Footer from '../components/common/Footer.vue';
import Button from '../components/common/Button.vue';
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBxpNV_8UazGQ3pMReWWIdROn7AZlMT17Y",
  authDomain: "baumind-45d99.firebaseapp.com",
  projectId: "baumind-45d99",
  storageBucket: "baumind-45d99.firebasestorage.app", 
  messagingSenderId: "982282716223",
  appId: "1:982282716223:web:25ebcf827c8e87c555248a",
  measurementId: "G-FDZLC80DZ2"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app);

const route = useRoute();
const project = ref(null);
const loading = ref(true);

const formattedSpecs = computed(() => {
  if (!project.value || !project.value.techSpecs) return [];
  return project.value.techSpecs.split('\n').filter(spec => spec.trim() !== '');
});

onMounted(async () => {
  AOS.init({once: false});
  try {
    const projectId = route.params.id; 
    
    if (!projectId || projectId === 'undefined') {
      loading.value = false;
      return;
    }

    const docRef = doc(db, "projeler", projectId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      project.value = docSnap.data();
      document.title = (project.value.title || 'Proje Detayı') + ' | BAU Innovation';
    } else {
      console.log("Veritabanında böyle bir proje ID'si yok:", projectId);
    }
  } catch (error) {
    console.error("Firebase çekme hatası:", error);
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
._container { background-color: #131619; font-family: 'DM Sans', sans-serif; min-height: 100vh; }
.introContainer { display: flex; flex-direction: row; justify-content: center; align-items: center; margin-bottom: 100px; padding-top: 50px; }
.introColImg { display: flex; justify-content: center; align-items: center; width: 50%; overflow: hidden; margin-right: 5%; }
.introImg { width: 100%; max-height: 600px; object-fit: contain; border-radius: 12px; }
.introColText { display: flex; width: 40%; flex-direction: column; }
.introColText .introTitle { font-family: 'DM Sans', sans-serif; color: aliceblue; font-size: 36px; margin-bottom: 20px; }
.introSubtitle { font-family: 'DM Sans', sans-serif; color: rgb(169, 167, 167); font-size: 18px; line-height: 30px; white-space: pre-wrap; }

@media screen and (max-width: 1023px) {
  .introContainer { flex-direction: column; padding: 5%; margin-bottom: 20px; }
  .introColImg { width: 100%; margin-right: 0; margin-bottom: 30px; }
  .introColText { width: 100%; }
}

.technicalContainer { display: flex; justify-content: center; flex-direction: row; margin-bottom: 100px; }
.technicalColText { display: flex; flex-direction: column; padding: 5%; width: 80%; background: #1a1d21; border-radius: 12px; }
.technicalColText .technicalTitle { font-family: 'DM Sans', sans-serif; color: #007bff; font-size: 30px; margin-bottom: 20px; border-bottom: 1px solid #2a2a2a; padding-bottom: 10px; }
.technicalList { font-family: 'DM Sans', sans-serif; color: rgb(169, 167, 167); font-size: 18px; line-height: 36px; padding-left: 20px; }

@media screen and (max-width: 1023px) {
  .technicalColText { width: 95%; }
}
</style>